import {
  SnippetElement,
  defineElement,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/common-cross-selling/common-cross-selling.ts
var CommonCrossSelling = class extends SnippetElement {
  connectedCallback() {
    this.fetchRecommendations();
  }
  fetchRecommendations() {
    return __async(this, null, function* () {
      var _a;
      try {
        const response = yield fetch((_a = this.getAttribute("data-url")) != null ? _a : "");
        const text = yield response.text();
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("common-cross-selling");
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      } catch (e) {
        console.error(e);
      }
    });
  }
};
__decorateClass([
  query("[data-recommendation]")
], CommonCrossSelling.prototype, "recommendation", 2);
CommonCrossSelling = __decorateClass([
  defineElement("common-cross-selling")
], CommonCrossSelling);
export {
  CommonCrossSelling
};
